import "core-js/modules/es.array.reverse.js";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _descriptor47, _descriptor48, _descriptor49, _descriptor50, _descriptor51, _descriptor52;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.sort.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action, computed, observable, reaction, runInAction, makeObservable } from "mobx";
import defined from "terriajs-cesium/Source/Core/defined";
import addedByUser from "../Core/addedByUser";
import { Category, HelpAction, StoryAction } from "../Core/AnalyticEvents/analyticEvents";
import Result from "../Core/Result";
import triggerResize from "../Core/triggerResize";
import CatalogMemberMixin, { getName } from "../ModelMixins/CatalogMemberMixin";
import GroupMixin from "../ModelMixins/GroupMixin";
import MappableMixin from "../ModelMixins/MappableMixin";
import ReferenceMixin from "../ModelMixins/ReferenceMixin";
import CommonStrata from "../Models/Definition/CommonStrata";
import getAncestors from "../Models/getAncestors";
import { SATELLITE_HELP_PROMPT_KEY } from "../ReactViews/HelpScreens/SatelliteHelpPrompt";
import { animationDuration } from "../ReactViews/StandardUserInterface/StandardUserInterface";
import { defaultTourPoints, RelativePosition } from "./defaultTourPoints";
import SearchState from "./SearchState";
import { getMarkerCatalogItem } from "../Models/LocationMarkerUtils";
export const DATA_CATALOG_NAME = "data-catalog";
export const USER_DATA_NAME = "my-data";

// check showWorkbenchButton delay and transforms
// export const WORKBENCH_RESIZE_ANIMATION_DURATION = 250;
export const WORKBENCH_RESIZE_ANIMATION_DURATION = 500;
/**
 * Root of a global view model. Presumably this should get nested as more stuff goes into it. Basically this belongs to
 * the root of the UI and then it can choose to pass either the whole thing or parts down as props to its children.
 */
let ViewState = (_class = class ViewState {
  get previewedItem() {
    return this._previewedItem;
  }
  setSelectedTrainerItem(trainerItem) {
    this.selectedTrainerItem = trainerItem;
  }
  setTrainerBarVisible(bool) {
    this.trainerBarVisible = bool;
  }
  setTrainerBarShowingAllSteps(bool) {
    this.trainerBarShowingAllSteps = bool;
  }
  setTrainerBarExpanded(bool) {
    this.trainerBarExpanded = bool;
    // if collapsing trainer bar, also hide steps
    if (!bool) {
      this.trainerBarShowingAllSteps = bool;
    }
  }
  setCurrentTrainerItemIndex(index) {
    this.currentTrainerItemIndex = index;
    this.currentTrainerStepIndex = 0;
  }
  setCurrentTrainerStepIndex(index) {
    this.currentTrainerStepIndex = index;
  }
  setActionBarVisible(visible) {
    this.isActionBarVisible = visible;
  }

  /**
   * Bottom dock state & action
   */

  setBottomDockHeight(height) {
    if (this.bottomDockHeight !== height) {
      this.bottomDockHeight = height;
    }
  }
  get tourPointsWithValidRefs() {
    // should viewstate.ts reach into document? seems unavoidable if we want
    // this to be the true source of tourPoints.
    // update: well it turns out you can be smarter about it and actually
    // properly clean up your refs - so we'll leave that up to the UI to
    // provide valid refs
    return this.tourPoints.slice().sort((a, b) => {
      return a.priority - b.priority;
    }).filter(tourPoint => {
      var _get;
      return (_get = this.appRefs.get(tourPoint.appRefName)) === null || _get === void 0 ? void 0 : _get.current;
    });
  }
  setTourIndex(index) {
    this.currentTourIndex = index;
  }
  setShowTour(bool) {
    // If we're enabling the tour, make sure the trainer is collapsed
    if (bool) {
      this.setTrainerBarExpanded(false);
      // Ensure workbench is shown
      this.setIsMapFullScreen(false);
      setTimeout(() => {
        runInAction(() => {
          this.showTour = bool;
        });
      }, animationDuration || 1);
    } else {
      this.showTour = bool;
    }
  }
  closeTour() {
    this.currentTourIndex = -1;
    this.showTour = false;
  }
  previousTourPoint() {
    const currentIndex = this.currentTourIndex;
    if (currentIndex !== 0) {
      this.currentTourIndex = currentIndex - 1;
    }
  }
  nextTourPoint() {
    const totalTourPoints = this.tourPointsWithValidRefs.length;
    const currentIndex = this.currentTourIndex;
    if (currentIndex >= totalTourPoints - 1) {
      this.closeTour();
    } else {
      this.currentTourIndex = currentIndex + 1;
    }
  }
  closeCollapsedNavigation() {
    this.showCollapsedNavigation = false;
  }
  updateAppRef(refName, ref) {
    if (!this.appRefs.get(refName) || this.appRefs.get(refName) !== ref) {
      this.appRefs.set(refName, ref);
    }
  }
  deleteAppRef(refName) {
    this.appRefs.delete(refName);
  }

  /**
   * Gets or sets a value indicating whether the small screen (mobile) user interface should be used.
   * @type {Boolean}
   */

  constructor(options) {
    _defineProperty(this, "mobileViewOptions", Object.freeze({
      data: "data",
      preview: "preview",
      nowViewing: "nowViewing",
      locationSearchResults: "locationSearchResults"
    }));
    _defineProperty(this, "searchState", void 0);
    _defineProperty(this, "terria", void 0);
    _defineProperty(this, "relativePosition", RelativePosition);
    _initializerDefineProperty(this, "_previewedItem", _descriptor, this);
    _initializerDefineProperty(this, "userDataPreviewedItem", _descriptor2, this);
    _initializerDefineProperty(this, "explorerPanelIsVisible", _descriptor3, this);
    _initializerDefineProperty(this, "activeTabCategory", _descriptor4, this);
    _initializerDefineProperty(this, "activeTabIdInCategory", _descriptor5, this);
    _initializerDefineProperty(this, "isDraggingDroppingFile", _descriptor6, this);
    _initializerDefineProperty(this, "mobileView", _descriptor7, this);
    _initializerDefineProperty(this, "isMapFullScreen", _descriptor8, this);
    _initializerDefineProperty(this, "myDataIsUploadView", _descriptor9, this);
    _initializerDefineProperty(this, "mobileMenuVisible", _descriptor0, this);
    _initializerDefineProperty(this, "explorerPanelAnimating", _descriptor1, this);
    _initializerDefineProperty(this, "topElement", _descriptor10, this);
    // Map for storing react portal containers created by <Portal> component.
    _initializerDefineProperty(this, "portals", _descriptor11, this);
    _initializerDefineProperty(this, "storyBuilderShown", _descriptor12, this);
    // Flesh out later
    _initializerDefineProperty(this, "showHelpMenu", _descriptor13, this);
    _initializerDefineProperty(this, "showSatelliteGuidance", _descriptor14, this);
    _initializerDefineProperty(this, "showWelcomeMessage", _descriptor15, this);
    _initializerDefineProperty(this, "selectedHelpMenuItem", _descriptor16, this);
    _initializerDefineProperty(this, "helpPanelExpanded", _descriptor17, this);
    _initializerDefineProperty(this, "disclaimerSettings", _descriptor18, this);
    _initializerDefineProperty(this, "disclaimerVisible", _descriptor19, this);
    _initializerDefineProperty(this, "videoGuideVisible", _descriptor20, this);
    _initializerDefineProperty(this, "trainerBarVisible", _descriptor21, this);
    _initializerDefineProperty(this, "trainerBarExpanded", _descriptor22, this);
    _initializerDefineProperty(this, "trainerBarShowingAllSteps", _descriptor23, this);
    _initializerDefineProperty(this, "selectedTrainerItem", _descriptor24, this);
    _initializerDefineProperty(this, "currentTrainerItemIndex", _descriptor25, this);
    _initializerDefineProperty(this, "currentTrainerStepIndex", _descriptor26, this);
    _initializerDefineProperty(this, "printWindow", _descriptor27, this);
    /**
     * The currently-selected web service type on the My Data -> Add web data panel.
     */
    _initializerDefineProperty(this, "remoteDataType", _descriptor28, this);
    /**
     * The ID of the Cesium ion token that is currently selected on the
     * My Data -> Add web data -> Cesium ion panel.
     */
    _initializerDefineProperty(this, "currentCesiumIonToken", _descriptor29, this);
    /**
     * Toggles ActionBar visibility. Do not set manually, it is
     * automatically set when rendering <ActionBar>
     */
    _initializerDefineProperty(this, "isActionBarVisible", _descriptor30, this);
    /**
     * A global list of functions that generate a {@link ViewingControl} option
     * for the given catalog item instance.  This is useful for plugins to extend
     * the viewing control menu across catalog items.
     *
     * Use {@link ViewingControlsMenu.addMenuItem} instead of updating directly.
     */
    _initializerDefineProperty(this, "globalViewingControlOptions", _descriptor31, this);
    /**
     * A global list of hooks for generating input controls for items in the workbench.
     * The hooks in this list gets called once for each item in shown in the workbench.
     * This is a mechanism for plugins to extend workbench input controls by adding new ones.
     *
     * Use {@link WorkbenchItem.Inputs.addInput} instead of updating directly.
     */
    _initializerDefineProperty(this, "workbenchItemInputGenerators", _descriptor32, this);
    /**
     * A global list of generator functions for showing buttons in feature info panel.
     * Use {@link FeatureInfoPanelButton.addButton} instead of updating directly.
     */
    _initializerDefineProperty(this, "featureInfoPanelButtonGenerators", _descriptor33, this);
    _initializerDefineProperty(this, "bottomDockHeight", _descriptor34, this);
    _defineProperty(this, "errorProvider", null);
    // default value is null, because user has not made decision to show or
    // not show story
    // will be explicitly set to false when user 1. dismiss story
    // notification or 2. close a story
    _initializerDefineProperty(this, "storyShown", _descriptor35, this);
    _initializerDefineProperty(this, "currentStoryId", _descriptor36, this);
    _initializerDefineProperty(this, "featurePrompts", _descriptor37, this);
    /**
     * we need a layering system for touring the app, but also a way for it to be
     * chopped and changed from a terriamap
     *
     * this will be slightly different to the help sequences that were done in
     * the past, but may evolve to become a "sequence" (where the UI gets
     * programatically toggled to delve deeper into the app, e.g. show the user
     * how to add data via the data catalog window)
     *
     * rough points
     * - "all guide points visible"
     * -
     *
      * draft structure(?):
     *
     * maybe each "guide" item will have
     * {
     *  ref: (react ref object)
     *  dotOffset: (which way the dot and guide should be positioned relative to the ref component)
     *  content: (component, more flexibility than a string)
     * ...?
     * }
     * and guide props?
     * {
     *  enabled: parent component to decide this based on active index
     * ...?
     * }
     *  */
    _initializerDefineProperty(this, "tourPoints", _descriptor38, this);
    _initializerDefineProperty(this, "showTour", _descriptor39, this);
    _initializerDefineProperty(this, "appRefs", _descriptor40, this);
    _initializerDefineProperty(this, "currentTourIndex", _descriptor41, this);
    _initializerDefineProperty(this, "showCollapsedNavigation", _descriptor42, this);
    _initializerDefineProperty(this, "useSmallScreenInterface", _descriptor43, this);
    /**
     * Gets or sets a value indicating whether the feature info panel is visible.
     * @type {Boolean}
     */
    _initializerDefineProperty(this, "featureInfoPanelIsVisible", _descriptor44, this);
    /**
     * Gets or sets a value indicating whether the feature info panel is collapsed.
     * When it's collapsed, only the title bar is visible.
     * @type {Boolean}
     */
    _initializerDefineProperty(this, "featureInfoPanelIsCollapsed", _descriptor45, this);
    /**
     * True if this is (or will be) the first time the user has added data to the map.
     * @type {Boolean}
     */
    _initializerDefineProperty(this, "firstTimeAddingData", _descriptor46, this);
    /**
     * Gets or sets a value indicating whether the feedback form is visible.
     * @type {Boolean}
     */
    _initializerDefineProperty(this, "feedbackFormIsVisible", _descriptor47, this);
    /**
     * Gets or sets a value indicating whether the catalog's modal share panel
     * is currently visible.
     */
    _initializerDefineProperty(this, "shareModalIsVisible", _descriptor48, this);
    // Small share modal inside StoryEditor
    /**
     * Used to indicate that the Share Panel should stay open even if it loses focus.
     * This is used when clicking a help link in the Share Panel - The Help Panel will open, and when it is closed, the Share Panel should still be visible for the user to continue their task.
     */
    _initializerDefineProperty(this, "retainSharePanel", _descriptor49, this);
    // The large share panel accessed via Share/Print button
    _initializerDefineProperty(this, "settingsPanelIsVisible", _descriptor50, this);
    /**
     * The currently open tool
     */
    _initializerDefineProperty(this, "currentTool", _descriptor51, this);
    _initializerDefineProperty(this, "panel", _descriptor52, this);
    _defineProperty(this, "_pickedFeaturesSubscription", void 0);
    _defineProperty(this, "_disclaimerVisibleSubscription", void 0);
    _defineProperty(this, "_isMapFullScreenSubscription", void 0);
    _defineProperty(this, "_showStoriesSubscription", void 0);
    _defineProperty(this, "_mobileMenuSubscription", void 0);
    _defineProperty(this, "_storyPromptSubscription", void 0);
    _defineProperty(this, "_previewedItemIdSubscription", void 0);
    _defineProperty(this, "_locationMarkerSubscription", void 0);
    _defineProperty(this, "_workbenchHasTimeWMSSubscription", void 0);
    _defineProperty(this, "_storyBeforeUnloadSubscription", void 0);
    makeObservable(this);
    const terria = options.terria;
    this.searchState = new SearchState({
      terria,
      catalogSearchProvider: options.catalogSearchProvider
    });
    this.errorProvider = options.errorHandlingProvider ? options.errorHandlingProvider : null;
    this.terria = terria;

    // When features are picked, show the feature info panel.
    this._pickedFeaturesSubscription = reaction(() => this.terria.pickedFeatures, pickedFeatures => {
      if (defined(pickedFeatures)) {
        this.featureInfoPanelIsVisible = true;
        this.featureInfoPanelIsCollapsed = false;
      } else {
        this.featureInfoPanelIsVisible = false;
      }
    });
    // When disclaimer is shown, ensure fullscreen
    // unsure about this behaviour because it nudges the user off center
    // of the original camera set from config once they acknowdge
    this._disclaimerVisibleSubscription = reaction(() => this.disclaimerVisible, disclaimerVisible => {
      this.isMapFullScreen = disclaimerVisible || terria.userProperties.get("hideWorkbench") === "1" || terria.userProperties.get("hideExplorerPanel") === "1";
    });
    this._isMapFullScreenSubscription = reaction(() => terria.userProperties.get("hideWorkbench") === "1" || terria.userProperties.get("hideExplorerPanel") === "1", isMapFullScreen => {
      this.isMapFullScreen = isMapFullScreen;

      // if /#hideWorkbench=1 exists in url onload, show stories directly
      // any show/hide workbench will not automatically show story
      if (!defined(this.storyShown)) {
        // why only check config params here? because terria.stories are not
        // set at the moment, and that property will be checked in rendering
        // Here are all are checking are: is terria story enabled in this app?
        // if so we should show it when app first load, if workbench is hidden
        this.storyShown = terria.configParameters.storyEnabled;
      }
    });
    this._showStoriesSubscription = reaction(() => Boolean(terria.userProperties.get("playStory")), playStory => {
      this.storyShown = terria.configParameters.storyEnabled && playStory;
    });
    this._mobileMenuSubscription = reaction(() => this.mobileMenuVisible, mobileMenuVisible => {
      if (mobileMenuVisible) {
        this.explorerPanelIsVisible = false;
        this.switchMobileView(null);
      }
    });
    this._workbenchHasTimeWMSSubscription = reaction(() => this.terria.workbench.hasTimeWMS, hasTimeWMS => {
      if (this.terria.configParameters.showInAppGuides && hasTimeWMS === true &&
      // // only show it once
      !this.terria.getLocalProperty("".concat(SATELLITE_HELP_PROMPT_KEY, "Prompted"))) {
        this.setShowSatelliteGuidance(true);
        this.toggleFeaturePrompt(SATELLITE_HELP_PROMPT_KEY, true, true);
      }
    });
    this._storyPromptSubscription = reaction(() => this.storyShown, storyShown => {
      if (storyShown === false) {
        // only show it once
        if (!this.terria.getLocalProperty("storyPrompted")) {
          this.toggleFeaturePrompt("story", true, false);
        }
      }
    });
    this._locationMarkerSubscription = reaction(() => getMarkerCatalogItem(this.terria), item => {
      if (item) {
        terria.overlays.add(item);
        /* dispose subscription after init */
        this._locationMarkerSubscription();
      }
    });
    this._previewedItemIdSubscription = reaction(() => this.terria.previewedItemId, async previewedItemId => {
      if (previewedItemId === undefined) {
        return;
      }
      try {
        const result = await this.terria.getModelByIdShareKeyOrCatalogIndex(previewedItemId);
        result.throwIfError();
        const model = result.throwIfUndefined();
        this.viewCatalogMember(model);
      } catch (e) {
        terria.raiseErrorToUser(e, {
          message: "Couldn't find model `".concat(previewedItemId, "` for preview")
        });
      }
    });
    const handleWindowClose = e => {
      // Cancel the event
      e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
      // Chrome requires returnValue to be set
      e.returnValue = "";
    };
    this._storyBeforeUnloadSubscription = reaction(() => this.terria.stories.length > 0, hasScenes => {
      if (hasScenes) {
        window.addEventListener("beforeunload", handleWindowClose);
      } else {
        window.removeEventListener("beforeunload", handleWindowClose);
      }
    });
  }
  dispose() {
    this._pickedFeaturesSubscription();
    this._disclaimerVisibleSubscription();
    this._mobileMenuSubscription();
    this._isMapFullScreenSubscription();
    this._showStoriesSubscription();
    this._storyPromptSubscription();
    this._previewedItemIdSubscription();
    this._workbenchHasTimeWMSSubscription();
    this._locationMarkerSubscription();
    this._storyBeforeUnloadSubscription();
    this.searchState.dispose();
  }
  triggerResizeEvent() {
    triggerResize();
  }
  setIsMapFullScreen(bool) {
    let animationDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : WORKBENCH_RESIZE_ANIMATION_DURATION;
    this.isMapFullScreen = bool;
    // Allow any animations to finish, then trigger a resize.

    // (wing): much better to do by listening for transitionend, but will leave
    // this as is until that's in place
    setTimeout(function () {
      // should we do this here in viewstate? it pulls in browser dependent things,
      // and (defensively) calls it.
      // but only way to ensure we trigger this resize, by standardising fullscreen
      // toggle through an action.
      triggerResize();
    }, animationDuration);
  }
  toggleStoryBuilder() {
    this.storyBuilderShown = !this.storyBuilderShown;
  }
  setTopElement(key) {
    this.topElement = key;
  }
  openAddData() {
    this.explorerPanelIsVisible = true;
    this.activeTabCategory = DATA_CATALOG_NAME;
    this.switchMobileView(this.mobileViewOptions.data);
  }
  openUserData() {
    this.explorerPanelIsVisible = true;
    this.activeTabCategory = USER_DATA_NAME;
  }
  closeCatalog() {
    this.explorerPanelIsVisible = false;
    this.switchMobileView(null);
    this.clearPreviewedItem();
  }
  searchInCatalog(query) {
    this.openAddData();
    this.searchState.catalogSearchText = query;
    this.searchState.searchCatalog();
  }

  /**
   * Open settings panel
   */
  openSettingsPanel() {
    this.settingsPanelIsVisible = true;
  }
  clearPreviewedItem() {
    this.userDataPreviewedItem = undefined;
    this._previewedItem = undefined;
  }

  /**
   * Views a model in the catalog. If model is a
   *
   * - `Reference` - it will be dereferenced first.
   * - `CatalogMember` - `loadMetadata` will be called
   * - `Group` - its `isOpen` trait will be set according to the value of the `isOpen` parameter in the `stratum` indicated.
   *   - If after doing this the group is open, its members will be loaded with a call to `loadMembers`.
   * - `Mappable` - `loadMapItems` will be called
   *
   * Then (if no errors have occurred) it will open the catalog.
   * Note - `previewItem` is set at the start of the function, regardless of errors.
   *
   * @param item The model to view in catalog.
   * @param [isOpen=true] True if the group should be opened. False if it should be closed.
   * @param stratum The stratum in which to mark the group opened or closed.
   * @param openAddData True if data catalog window should be opened.
   */
  async viewCatalogMember(item) {
    let isOpen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    let stratum = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : CommonStrata.user;
    let openAddData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    // Set preview item before loading - so we can see loading indicator and errors in DataPreview panel.
    runInAction(() => this._previewedItem = item);
    try {
      // If item is a Reference - recursively load and call viewCatalogMember on the target
      if (ReferenceMixin.isMixedInto(item)) {
        (await item.loadReference()).throwIfError();
        if (item.target) {
          return this.viewCatalogMember(item.target);
        } else {
          return Result.error("Could not view catalog member ".concat(getName(item)));
        }
      }

      // Open "Add Data"
      if (openAddData) {
        if (addedByUser(item)) {
          runInAction(() => this.userDataPreviewedItem = item);
          this.openUserData();
        } else {
          runInAction(() => {
            this.openAddData();
            if (this.terria.configParameters.tabbedCatalog) {
              const parentGroups = getAncestors(item);
              if (parentGroups.length > 0) {
                // Go to specific tab
                this.activeTabIdInCategory = parentGroups[0].uniqueId;
              }
            }
          });
        }

        // mobile switch to now viewing if not viewing a group
        if (!GroupMixin.isMixedInto(item)) {
          this.switchMobileView(this.mobileViewOptions.preview);
        }
      }
      if (GroupMixin.isMixedInto(item)) {
        item.setTrait(stratum, "isOpen", isOpen);
        if (item.isOpen) {
          (await item.loadMembers()).throwIfError();
        }
      } else if (MappableMixin.isMixedInto(item)) (await item.loadMapItems()).throwIfError();else if (CatalogMemberMixin.isMixedInto(item)) (await item.loadMetadata()).throwIfError();
    } catch (e) {
      return Result.error(e, "Could not view catalog member ".concat(getName(item)));
    }
    return Result.none();
  }
  switchMobileView(viewName) {
    this.mobileView = viewName;
  }
  showHelpPanel() {
    var _this$terria$analytic;
    (_this$terria$analytic = this.terria.analytics) === null || _this$terria$analytic === void 0 || _this$terria$analytic.logEvent(Category.help, HelpAction.panelOpened);
    this.showHelpMenu = true;
    this.helpPanelExpanded = false;
    this.selectedHelpMenuItem = "";
    this.setTopElement("HelpPanel");
  }
  openHelpPanelItemFromSharePanel(evt, itemName) {
    evt.preventDefault();
    evt.stopPropagation();
    this.setRetainSharePanel(true);
    this.showHelpPanel();
    this.selectHelpMenuItem(itemName);
  }
  selectHelpMenuItem(key) {
    this.selectedHelpMenuItem = key;
    this.helpPanelExpanded = true;
  }
  hideHelpPanel() {
    this.showHelpMenu = false;
  }
  setRetainSharePanel(retain) {
    this.retainSharePanel = retain;
  }
  changeSearchState(newText) {
    this.searchState.catalogSearchText = newText;
  }
  setDisclaimerVisible(bool) {
    this.disclaimerVisible = bool;
  }
  hideDisclaimer() {
    this.setDisclaimerVisible(false);
  }
  setShowSatelliteGuidance(showSatelliteGuidance) {
    this.showSatelliteGuidance = showSatelliteGuidance;
  }
  setShowWelcomeMessage(welcomeMessageShown) {
    this.showWelcomeMessage = welcomeMessageShown;
  }
  setVideoGuideVisible(videoName) {
    this.videoGuideVisible = videoName;
  }

  /**
   * Removes references of a model from viewState
   */
  removeModelReferences(model) {
    if (this._previewedItem === model) this._previewedItem = undefined;
    if (this.userDataPreviewedItem === model) this.userDataPreviewedItem = undefined;
  }
  toggleFeaturePrompt(feature, state) {
    let persistent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    const featureIndexInPrompts = this.featurePrompts.indexOf(feature);
    if (state && featureIndexInPrompts < 0 && !this.terria.getLocalProperty("".concat(feature, "Prompted"))) {
      this.featurePrompts.push(feature);
    } else if (!state && featureIndexInPrompts >= 0) {
      this.featurePrompts.splice(featureIndexInPrompts, 1);
    }
    if (persistent) {
      this.terria.setLocalProperty("".concat(feature, "Prompted"), true);
    }
  }
  viewingUserData() {
    return this.activeTabCategory === USER_DATA_NAME;
  }
  afterTerriaStarted() {
    if (this.terria.configParameters.openAddData) {
      this.openAddData();
    }
  }
  openTool(tool) {
    this.currentTool = tool;
  }
  closeTool() {
    this.currentTool = undefined;
  }
  setPrintWindow(window) {
    if (this.printWindow) {
      this.printWindow.close();
    }
    this.printWindow = window;
  }
  toggleMobileMenu() {
    this.setTopElement("mobileMenu");
    this.mobileMenuVisible = !this.mobileMenuVisible;
  }
  runStories() {
    var _this$terria$analytic2;
    this.storyBuilderShown = false;
    this.storyShown = true;
    setTimeout(function () {
      triggerResize();
    }, animationDuration || 1);
    this.terria.currentViewer.notifyRepaintRequired();
    (_this$terria$analytic2 = this.terria.analytics) === null || _this$terria$analytic2 === void 0 || _this$terria$analytic2.logEvent(Category.story, StoryAction.runStory);
  }
  get breadcrumbsShown() {
    return this.previewedItem !== undefined || this.userDataPreviewedItem !== undefined;
  }
  get isToolOpen() {
    return this.currentTool !== undefined;
  }
  get hideMapUi() {
    return this.terria.notificationState.currentNotification !== undefined && this.terria.notificationState.currentNotification.hideUi;
  }
  get isMapZooming() {
    return this.terria.currentViewer.isMapZooming;
  }

  /**
   * Returns true if the user is currently interacting with the map - like
   * picking a point or drawing a shape.
   */
  get isMapInteractionActive() {
    return this.terria.mapInteractionModeStack.length > 0;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "_previewedItem", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "userDataPreviewedItem", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "explorerPanelIsVisible", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "activeTabCategory", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return DATA_CATALOG_NAME;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "activeTabIdInCategory", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isDraggingDroppingFile", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "mobileView", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "isMapFullScreen", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "myDataIsUploadView", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "mobileMenuVisible", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "explorerPanelAnimating", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "topElement", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "FeatureInfo";
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "portals", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new Map();
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "storyBuilderShown", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "showHelpMenu", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "showSatelliteGuidance", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "showWelcomeMessage", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "selectedHelpMenuItem", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "";
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "helpPanelExpanded", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "disclaimerSettings", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "disclaimerVisible", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "videoGuideVisible", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "";
  }
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "trainerBarVisible", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "trainerBarExpanded", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "trainerBarShowingAllSteps", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "selectedTrainerItem", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "";
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "currentTrainerItemIndex", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "currentTrainerStepIndex", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "printWindow", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "remoteDataType", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "currentCesiumIonToken", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "isActionBarVisible", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "globalViewingControlOptions", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "workbenchItemInputGenerators", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "featureInfoPanelButtonGenerators", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "setSelectedTrainerItem", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedTrainerItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setTrainerBarVisible", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setTrainerBarVisible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setTrainerBarShowingAllSteps", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setTrainerBarShowingAllSteps"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setTrainerBarExpanded", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setTrainerBarExpanded"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCurrentTrainerItemIndex", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setCurrentTrainerItemIndex"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setCurrentTrainerStepIndex", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setCurrentTrainerStepIndex"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setActionBarVisible", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setActionBarVisible"), _class.prototype), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "bottomDockHeight", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _applyDecoratedDescriptor(_class.prototype, "setBottomDockHeight", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setBottomDockHeight"), _class.prototype), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "storyShown", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "currentStoryId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "featurePrompts", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "tourPoints", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return defaultTourPoints;
  }
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "showTour", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "appRefs", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new Map();
  }
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "currentTourIndex", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return -1;
  }
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "showCollapsedNavigation", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "tourPointsWithValidRefs", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "tourPointsWithValidRefs"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setTourIndex", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setTourIndex"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShowTour", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowTour"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeTour", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeTour"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "previousTourPoint", [action], Object.getOwnPropertyDescriptor(_class.prototype, "previousTourPoint"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "nextTourPoint", [action], Object.getOwnPropertyDescriptor(_class.prototype, "nextTourPoint"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeCollapsedNavigation", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeCollapsedNavigation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateAppRef", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateAppRef"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deleteAppRef", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deleteAppRef"), _class.prototype), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "useSmallScreenInterface", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "featureInfoPanelIsVisible", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "featureInfoPanelIsCollapsed", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "firstTimeAddingData", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor47 = _applyDecoratedDescriptor(_class.prototype, "feedbackFormIsVisible", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor48 = _applyDecoratedDescriptor(_class.prototype, "shareModalIsVisible", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor49 = _applyDecoratedDescriptor(_class.prototype, "retainSharePanel", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor50 = _applyDecoratedDescriptor(_class.prototype, "settingsPanelIsVisible", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor51 = _applyDecoratedDescriptor(_class.prototype, "currentTool", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor52 = _applyDecoratedDescriptor(_class.prototype, "panel", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "triggerResizeEvent", [action], Object.getOwnPropertyDescriptor(_class.prototype, "triggerResizeEvent"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setIsMapFullScreen", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsMapFullScreen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleStoryBuilder", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleStoryBuilder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setTopElement", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setTopElement"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openAddData", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openAddData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openUserData", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openUserData"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeCatalog", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeCatalog"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "searchInCatalog", [action], Object.getOwnPropertyDescriptor(_class.prototype, "searchInCatalog"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openSettingsPanel", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openSettingsPanel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearPreviewedItem", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clearPreviewedItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "switchMobileView", [action], Object.getOwnPropertyDescriptor(_class.prototype, "switchMobileView"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showHelpPanel", [action], Object.getOwnPropertyDescriptor(_class.prototype, "showHelpPanel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openHelpPanelItemFromSharePanel", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openHelpPanelItemFromSharePanel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectHelpMenuItem", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectHelpMenuItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideHelpPanel", [action], Object.getOwnPropertyDescriptor(_class.prototype, "hideHelpPanel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setRetainSharePanel", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setRetainSharePanel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "changeSearchState", [action], Object.getOwnPropertyDescriptor(_class.prototype, "changeSearchState"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setDisclaimerVisible", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setDisclaimerVisible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideDisclaimer", [action], Object.getOwnPropertyDescriptor(_class.prototype, "hideDisclaimer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShowSatelliteGuidance", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowSatelliteGuidance"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setShowWelcomeMessage", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setShowWelcomeMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setVideoGuideVisible", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setVideoGuideVisible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "removeModelReferences", [action], Object.getOwnPropertyDescriptor(_class.prototype, "removeModelReferences"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleFeaturePrompt", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleFeaturePrompt"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openTool", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openTool"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeTool", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeTool"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPrintWindow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPrintWindow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleMobileMenu", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleMobileMenu"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "runStories", [action], Object.getOwnPropertyDescriptor(_class.prototype, "runStories"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "breadcrumbsShown", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "breadcrumbsShown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isToolOpen", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isToolOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideMapUi", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "hideMapUi"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isMapInteractionActive", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isMapInteractionActive"), _class.prototype), _class);
export { ViewState as default };